import Repository from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";
import { UserBasedUserPaymentMethodSerializer } from "../types/payment-types";

export default class UserBasedPaymentMethodRepository extends Repository<UserBasedUserPaymentMethodSerializer> {
  public readonly repositoryName = "UserBasedPaymentMethodRepository";

  public readonly endpoint = "api/user/financials/user-payment-methods";

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
    };
  }
}
